import { getSchedulerDataServicesInstall } from "../services";
import { filteredServicesComponents } from "../filteredServicesComponent"

export function electricalInstallation() {

  let servicesStart = [
    {
      id: "Indoors",
      label: <>Indoors</>,
      data: [
        [
          {
            name: "Indoors",
            question: "Indoors",
            answers: [
              {
                id: "Switches, Outlets, & Fixtures",
                label: <>Switches, Outlets, & Fixtures</>,
                value: "Switches, Outlets, & Fixtures",
                jobType: "Switches, Outlets, Fixtures",
                remType: "estimate"
              },
              {
                id: "Lighting",
                label: <>Lighting</>,
                value: "Lighting",
                jobType: "Indoor Lighting",
                remType: "estimate"
              },
              {
                id: "Breaker Panel",
                label: <>Breaker Panel</>,
                value: "Breaker Panel",
                jobType: "Breaker Panel",
                remType: "estimate"
              },
              {
                id: "Ceiling Fan",
                label: <>Ceiling Fan</>,
                value: "Ceiling Fan",
                jobType: "Ceiling Fan",
                remType: "estimate"
              },
              {
                id: "Exhaust Fan",
                label: <>Exhaust Fan</>,
                value: "Exhaust Fan",
                jobType: "Exhaust Fan",
                remType: "estimate"
              },
              {
                id: "Surge Protector",
                label: <>Surge Protector</>,
                value: "Surge Protector",
                jobType: "Surge Protector",
                remType: "estimate"
              },
              {
                id: "Entertainment Center Wiring",
                label: <>Entertainment Center Wiring</>,
                value: "Entertainment Center Wiring",
                jobType: "Entertainment Center Wiring",
                remType: "estimate"
              },
              {
                id: "Smoke/Carbon Monoxide Detectors",
                label: <>Smoke/Carbon Monoxide Detectors</>,
                value: "Smoke/Carbon Monoxide Detectors",
                jobType: "Smoke & Carbon Monoxide Detectors",
                remType: "estimate"
              },
              {
                id: "Smart Home",
                label: <>Smart Home</>,
                value: "Smart Home",
                jobType: "Smart Home",
                remType: "estimate"
              },
              {
                id: "Hot Tub Wiring",
                label: <>Hot Tub Wiring</>,
                value: "Hot Tub Wiring",
                jobType: "Hot Tub Wiring",
                remType: "estimate"
              },
              {
                id: "Wiring",
                label: <>Wiring</>,
                value: "Wiring",
                jobType: "Wiring",
                remType: "estimate"
              },
            ],
          },
        ],
      ],
    },
    {
      id: "Outdoors",
      label: <>Outdoors</>,
      data: [
        [
          {
            name: "Outdoors",
            question: "Outdoors",
            answers: [
              {
                id: "Security/Motion Lights",
                label: <>Security/Motion Lights</>,
                value: "Security/Motion Lights",
                jobType: "Security/Motion Light",
                remType: "estimate"
              },
              {
                id: "Outdoor Outlet",
                label: <>Outdoor Outlet</>,
                value: "Outdoor Outlet",
                jobType: "Outdoor Outlet",
                remType: "estimate"
              },
              {
                id: "Outdoor Lighting",
                label: <>Outdoor Lighting</>,
                value: "Outdoor Lighting",
                jobType: "Outdoor Lighting",
                remType: "estimate"
              },
              {
                id: "Meter Base",
                label: <>Meter Base</>,
                value: "Meter Base",
                jobType: "Meter Base",
                remType: "estimate"
              },
              {
                id: "Lightning Protection",
                label: <>Lightning Protection</>,
                value: "Lightning Protection",
                jobType: "Lightning Protection",
                remType: "estimate"
              },
            ],
          },
        ],
      ],
    },
    {
      id: "Vehicle Charging Station",
      label: <>Vehicle Charging Station</>,
      value: "Vehicle Charging Station",
      jobType: "Vehicle Charging Station",
      remType: "estimate"
    },
    {
      id: "Home Remodel",
      label: <>Home Remodel</>,
      value: "Home Remodel",
      jobType: "Home Remodels",
      remType: "estimate"
    },
  ];

  const jobTypeFilter = getSchedulerDataServicesInstall// Replace with the desired job type to filter

  return filteredServicesComponents(servicesStart, jobTypeFilter);

}

